import { CreateQueryHistoryBulkInput, CreateQueryHistoryBulkResponse, CreateQueryHistoryInput, QueryHistory } from '@/models/gen/graphql';

import { CreateQueryHistoryBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import { Validation } from '@/utils';
import graphApi from '@/api';

type CreateQueryHistoryBulkGraphApiResponse = GraphApiResponse<typeof CreateQueryHistoryBulkDocument>;

export const createQueryHistoryValidator = new Validation.Validator({
  'startDate!': (val: string): Validation.Validity => ({
    valid: Validation.isDate(val),
  }),
  'endDate!': (val: string): Validation.Validity => ({
    valid: Validation.isDate(val),
  }),
  'puLocationId!': (val: string): Validation.Validity => ({
    valid: Validation.isValidUUID(val),
  }),
  'doLocationId!': (val: string): Validation.Validity => ({
    valid: Validation.isValidUUID(val),
  }),
  interval: (val: string): Validation.Validity => ({
    valid: Validation.isNumber(parseInt(val)),
    defaultValue: '15',
  }),
});

const createQueryHistoryBulkResponseSelector = (res: CreateQueryHistoryBulkGraphApiResponse): CreateQueryHistoryBulkResponse =>
  !res.errors ? (res?.createQueryHistoryBulk as CreateQueryHistoryBulkResponse) : undefined;

const [runCreateQueryHistoryBulk] = graphApi(CreateQueryHistoryBulkDocument);

const createQueryHistoryBulk = async (queryHistorys: Partial<CreateQueryHistoryInput>[]): Promise<CreateQueryHistoryBulkResponse> => {
  const values: CreateQueryHistoryInput[] = queryHistorys.map(
    (queryHistory: QueryHistory): CreateQueryHistoryInput => createQueryHistoryValidator.create(queryHistory)
  );
  const input: CreateQueryHistoryBulkInput = { values };

  const res = await runCreateQueryHistoryBulk({ input });
  return createQueryHistoryBulkResponseSelector(res);
};

export default createQueryHistoryBulk;
